import { DateTime } from "luxon"

export const getMonthDates = (month: DateTime, end: string) => {
  const startDate = month.startOf("month")
  const endDate = month.endOf("month")
  let currentDate = startDate
  const dates: string[] = []

  while (
    currentDate.toJSDate() < endDate.toJSDate() &&
    currentDate.toJSDate() <= DateTime.fromISO(end).toJSDate()
  ) {
    dates.push(currentDate.toISODate() || "")
    currentDate = currentDate.plus({ days: 1 })
  }

  return dates
}
